import { jsxs as i, jsx as e } from "react/jsx-runtime";
import { forwardRef as R } from "react";
import { FORM_ELEMENT_PADDING_CLASS_NAME as S } from "../../constants/base-class-name.mjs";
import { twMerge as r } from "tailwind-merge";
import { FieldLabel as G } from "../form/field-label.mjs";
import { FieldErrorAndDescription as I } from "../form/field-error-and-description.mjs";
const U = R(function({
  error: l,
  label: m,
  labelClassName: p,
  labelRightElement: b,
  htmlFor: T,
  nativeLabelProps: c,
  value: x,
  onChange: u,
  onFocus: y,
  maxLength: f,
  placeholder: g,
  isPreFetching: t,
  required: N,
  description: h,
  className: k,
  addonBefore: a,
  addonAfter: o,
  inputClassName: w,
  success: v,
  addonAfterClassName: C,
  addonBeforeClassName: E,
  statusIcon: n,
  statusIconClassName: M,
  labelContentWrapperClassName: _,
  errorAndDescriptionClassName: j,
  descriptionClassName: D,
  errorClassName: F,
  ...d
}, L) {
  const s = r(
    "break-words flex justify-center items-center py-2.5 px-2 sm:px-4  border border-y-text-secondary/50",
    t ? "bg-skeleton-primary/40 text-transparent border-0" : "text-text-tertiary bg-background-tertiary"
  ), A = r(S, n && "pr-9");
  return /* @__PURE__ */ i(
    "label",
    {
      className: r("flex flex-col gap-1 text-sm font-medium", k),
      ...c,
      children: [
        /* @__PURE__ */ e(
          G,
          {
            label: m,
            labelClassName: p,
            labelRightElement: b,
            required: N
          }
        ),
        /* @__PURE__ */ i(
          "div",
          {
            className: r(
              "text-text-primary main-transition-colors relative flex w-full shrink-0 rounded-lg",
              t && "animate-pulse",
              _
            ),
            children: [
              a && /* @__PURE__ */ e(
                "div",
                {
                  className: r(
                    "border-l-text-secondary/50 rounded-l-lg border-r-transparent",
                    s,
                    E
                  ),
                  children: a
                }
              ),
              /* @__PURE__ */ e(
                "input",
                {
                  ref: L,
                  className: r(
                    "main-transition-colors focus:border-brand-primary placeholder:text-text-tertiary/70 placeholder-shown:truncate bg-background-secondary min-w-0 basis-full rounded-lg focus:outline-hidden",
                    A,
                    l ? "border-danger" : v ? "border-green" : "border-text-secondary/30",
                    t ? "bg-skeleton-primary/40 disabled:bg-skeleton-primary/40 border-0 text-transparent" : "disabled:bg-background-tertiary/40 border",
                    a && "rounded-l-none",
                    o && "rounded-r-none",
                    w
                  ),
                  type: d.type || "text",
                  value: x,
                  onChange: u,
                  onFocus: y,
                  maxLength: f,
                  placeholder: g,
                  spellCheck: !1,
                  disabled: d.disabled || t,
                  ...d
                }
              ),
              o && /* @__PURE__ */ e(
                "div",
                {
                  className: r(
                    "border-r-text-secondary/50 rounded-r-lg border-l-transparent",
                    s,
                    C
                  ),
                  children: o
                }
              ),
              n && /* @__PURE__ */ e(
                "div",
                {
                  className: r(
                    "absolute right-3 h-[21px] w-[21px] translate-y-1/2",
                    M
                  ),
                  children: n
                }
              )
            ]
          }
        ),
        /* @__PURE__ */ e(
          I,
          {
            description: h,
            error: l,
            className: j,
            descriptionClassName: D,
            errorClassName: F
          }
        )
      ]
    }
  );
});
export {
  U as FormInput
};
